import TaxiCorporationPlanEntryBillingsResponse, {
  TaxiCorporationPlanEntryBillingsResponseBillingModel,
  TaxiCorporationPlanEntryBillingsResponseDataItem,
  TaxiCorporationPlanEntryBillingsResponseDataStats,
} from "../../../../api/raily/taxi-corporation/plan-entry-billings/list/taxi-corporation-plan-entry-billings.response";
import BillingModel from "../../../../types/billing-model";
import TaxiCorporationPlanEntryBillings, {
  TaxiCorporationPlanEntryBillingsItem,
  TaxiCorporationPlanEntryBillingsStats,
} from "./taxi-corporation-plan-entry-billings";

const createBillingModel = (
  model: TaxiCorporationPlanEntryBillingsResponseBillingModel,
): BillingModel => {
  switch (model) {
    case TaxiCorporationPlanEntryBillingsResponseBillingModel.AB:
      return BillingModel.AB;
    case TaxiCorporationPlanEntryBillingsResponseBillingModel.ABA:
      return BillingModel.ABA;
    case TaxiCorporationPlanEntryBillingsResponseBillingModel.OTHER:
      return BillingModel.OTHER;
    case TaxiCorporationPlanEntryBillingsResponseBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItem = (
  item: TaxiCorporationPlanEntryBillingsResponseDataItem,
): TaxiCorporationPlanEntryBillingsItem => {
  return {
    allContributionsAmount: item.allContributionsAmount,
    amountForChargeHaltings: item.amountForChargeHaltings,
    amountForChargeHighways: item.amountForChargeHighways,
    amountForDistance: item.amountForDistance,
    baseDistanceRate: item.baseDistanceRate,
    billingModel: createBillingModel(item.billingModel),
    cargoOrderHumanIds: item.cargoOrderHumanIds,
    date: item.date,
    distance: item.distance,
    driver: item.driver,
    favorableDistance: item.favorableDistance,
    fleetPartner: item.fleetPartner,
    humanId: item.humanId,
    rateForDistance: item.rateForDistance,
    route: item.route,
    sumOfBonuses: item.sumOfBonuses,
    sumOfPenalties: item.sumOfPenalties,
    uuid: item.id,
  };
};

const createData = (
  data: TaxiCorporationPlanEntryBillingsResponseDataItem[],
): TaxiCorporationPlanEntryBillingsItem[] => {
  return data.map(createDataItem);
};

const createStats = (
  stats: TaxiCorporationPlanEntryBillingsResponseDataStats,
): TaxiCorporationPlanEntryBillingsStats => {
  return {
    allContributionsAmount: stats.allContributionsAmount,
    amountForChargeHaltings: stats.amountForChargeHaltings,
    amountForChargeHighways: stats.amountForChargeHighways,
    distance: stats.distance,
    sumOfBonuses: stats.sumOfBonuses,
    sumOfPenalties: stats.sumOfPenalties,
  };
};

const create = (
  response: TaxiCorporationPlanEntryBillingsResponse,
): TaxiCorporationPlanEntryBillings => {
  return {
    data: createData(response.data.data),
    stats: createStats(response.data.stats),
    totalCount: response.data.totalCount,
  };
};

const taxiCorporationPlanEntryBillingsFactory = {
  create,
};

export default taxiCorporationPlanEntryBillingsFactory;
